import {
  AdminBillingType,
  AdminSubscriptionFilters,
  AdminSubscriptionSortKey,
  AdminTransactionFilter,
} from './utils'

export const DEFAULT_FILTERS: AdminSubscriptionFilters = {
  search: '',
  status: 'all',
  paymentType: 'all',
  transactionStatus: 'all',
}

export const HEADER_CELLS: Array<{
  id: string
  label: string
  align?: 'left' | 'right' | 'center'
  sortKey?: AdminSubscriptionSortKey
}> = [
  { id: 'customerName', label: 'Customer', sortKey: 'customerName' },
  { id: 'phoneNumber', label: 'Phone' },
  { id: 'email', label: 'Email' },
  { id: 'address', label: 'Address' },
  { id: 'unitLabel', label: 'Unit', sortKey: 'unitLabel' },
  { id: 'startDate', label: 'Start Date', sortKey: 'startDate' },
  { id: 'amount', label: 'Monthly', align: 'right', sortKey: 'amount' },
  { id: 'paymentType', label: 'Billing', sortKey: 'paymentType' },
  {
    id: 'latestTransactionStatus',
    label: 'Last Charge',
    sortKey: 'latestTransactionStatus',
  },
  {
    id: 'transactionCount',
    label: 'Transactions',
    align: 'center',
    sortKey: 'transactionCount',
  },
  { id: 'status', label: 'Status', sortKey: 'status' },
]

export const EXPANDER_COLUMN_MIN_WIDTH = 56

export const HEADER_CELL_MIN_WIDTHS: Record<string, number> = {
  customerName: 180,
  phoneNumber: 120,
  email: 180,
  address: 260,
  unitLabel: 180,
  startDate: 130,
  amount: 110,
  paymentType: 100,
  latestTransactionStatus: 180,
  transactionCount: 110,
  status: 180,
}

export const SUBSCRIPTIONS_TABLE_MIN_WIDTH =
  EXPANDER_COLUMN_MIN_WIDTH +
  HEADER_CELLS.reduce(
    (total, cell) => total + (HEADER_CELL_MIN_WIDTHS[cell.id] ?? 140),
    0
  )

export const PAYMENT_TYPE_OPTIONS: Array<'all' | AdminBillingType> = [
  'all',
  'Card',
  'Bank',
  'Unknown',
]

export const TRANSACTION_STATUS_OPTIONS: AdminTransactionFilter[] = [
  'all',
  'settled',
  'pending',
  'failed',
  'none',
]
